<template>
  <footer class="bg-gray-50 border-t border-gray-200 py-12">
    <div
      class="max-w-7xl mx-auto px-6 flex flex-col justify-start items-center"
    >
      <div class="flex items-center gap-3 mb-5">
        <!-- Icon -->
        <div
          class="w-9 h-9 bg-red-700 rounded-lg flex items-center justify-center text-white shadow-sm"
        >
          <svg
            class="w-5 h-5"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z"
            ></path>
          </svg>
        </div>

        <!-- Text -->
        <div class="flex items-baseline gap-1.5">
          <span class="font-rounded font-bold text-2xl text-primary"
            >Happy<span class="text-yellow-500">Buy</span></span
          >
          <span class="w-1.5 h-1.5 rounded-full bg-red-700 mb-1"></span>
          <span class="font-tc text-sm font-medium text-gray-500"
            >電商系統</span
          >
        </div>
      </div>
      <p class="text-sm text-gray-500 mb-2">
        &copy; 2026 快樂購物系統 All rights reserved.
      </p>
      <p class="text-sm text-gray-500 mb-2">星期一至五 09:00 - 18:00</p>
      <div class="flex gap-4 text-sm text-gray-500">
        <a class="hover:text-black hover:underline transition-all">LINE@</a> |
        <a class="hover:text-black hover:underline transition-all"
          >0800-888-553</a
        >
        |
        <a class="hover:text-black hover:underline transition-all"
          >yongxin@yongxin-design.com</a
        >
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "MainFooter",
};
</script>
